import { Routes } from '@angular/router';

const title = 'Configuración';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'notificacion',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Notificaciones' }] },
        loadComponent: () => import('./pages/notificacion-lista/notificacion-lista.component'),
      },
    
    ],
  },
];
